<!-- input时间选择组件 -->
<template>
  <div>
    <InputValidate
      v-validate="'required'"
      :value="datePickerValue"
      :title="title"
      :name="name"
      data-vv-value-path="innerValue"
      :error="errors.first(`${name}`)"
      :readonly="true"
      @click.native="isDatePickerShow = true"
    />

    <md-date-picker
      ref="datePicker"
      v-model="isDatePickerShow"
      :ok-text="$t('done')"
      :cancel-text="$t('cancel')"
      type="custom"
      large-radius
      :text-render="textRender"
      :custom-types="['yyyy', 'MM', 'dd']"
      :default-date="currentDate"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="onDatePickerConfirm"
    />
  </div>
</template>

<script>
import { DatePicker, InputItem } from 'mand-mobile'
import InputValidate from '@/components/InputValidate'

export default {
  name: 'InputDatePicker',
  components: {
    [DatePicker.name]: DatePicker,
    [InputItem.name]: InputItem,
    InputValidate
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      minDate: new Date('1900/1/1'),
      maxDate: new Date(`${new Date().getFullYear() - 18}/${new Date().getMonth() + 1}/${new Date().getDate()}`), // 18可以注册
      currentDate: new Date(),
      isDatePickerShow: false
    }
  },

  computed: {
    datePickerValue () {
      return `${this.date}`.replaceAll('-', '/')
    }
  },

  watch: {
    date: {
      immediate: true,
      handler () {
        this.textRender()
      }
    }
  },

  methods: {
    textRender () {
      const args = Array.prototype.slice.call(arguments)
      const typeFormat = args[0] // 类型
      const column0Value = args[1] // 第1列选中值
      const column1Value = args[2] // 第2列选中值
      const column2Value = args[3] // 第3列选中值
      if (typeFormat === 'dd') {
        return `${column2Value}`.length === 1 ? `0${column2Value}` : `${column2Value}`
      }
      if (typeFormat === 'yyyy') {
        return column0Value
      }
      if (typeFormat === 'MM') {
        return `${column1Value}`.padStart(2, '0')
      }
    },
    onDatePickerConfirm () {
      this.$emit('update:date', this.$refs.datePicker.getFormatDate('yyyy-MM-dd'))
    },
    // 校验
    validate () {
      this.$validator.validate().then(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>
